import React from 'react';
import { useDispatch } from 'react-redux';

import useCompanyFeatures from '../../../../components/Authorizer/useCompanyFeatures';
import { AiFeatureTypes } from '../../../../constants/featureTypes';
import { hideModal, showModal } from '../../../../redux/modules/modal';

import ExtractedTemplateReviewModal from './ExtractedTemplateReviewModal';
import TemplatesFromContractModal from './TemplatesFromContractModal';

/**
 * Drives the upload contract → extract → review → select flow behind the
 * requirement template dropdown's Upload Contract button.
 *
 * Returns a click handler that opens the flow, or null when the company has
 * no AI tier feature enabled (which hides the button).
 */
const useUploadContractFlow = (companyId, onUseTemplate) => {
  const dispatch = useDispatch();
  const { companyHasFeature: aiScanEnabled } = useCompanyFeatures(AiFeatureTypes);

  if (!aiScanEnabled) return null;

  const showExtractedTemplateReviewModal = templateId => {
    dispatch(showModal(
      () => (
        <ExtractedTemplateReviewModal
          templateId={templateId}
          onUseTemplate={template => {
            onUseTemplate(template);
            dispatch(hideModal());
          }}
        />
      ),
      {
        size: '4xl',
        title: 'Review Extracted Requirements',
        actionRequired: true
      }
    ));
  };

  return () => {
    dispatch(showModal(
      () => (
        <TemplatesFromContractModal
          companyId={companyId}
          onExtractionComplete={showExtractedTemplateReviewModal}
        />
      ),
      {
        size: '4xl',
        title: 'Create From Contract',
        actionRequired: true
      }
    ));
  };
};

export default useUploadContractFlow;
